export default [{
		path: 'individualTax',
		component: () => import( /* webpackChunkName: "common-list" */ '@/pages/individualTax/declarationCenter/index'),
		name: 'individualTax',
		meta: {
			title: '申报中心',
			keepAlive: true
		},

	},
	{
		path: 'individualTaxDetail',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationCenter/detail'),
		name: 'individualTaxDetail',
		meta: {
			title: '申报详情'
		},
	},
	{
		path: 'individualServiceList',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationCenter/serviceList'),
		name: 'individualServiceList',
		meta: {
			title: '服务商列表'
		},
	},
	{
		path: 'individualCompanyList',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationCenter/companyList'),
		name: 'individualCompanyList',
		meta: {
			title: '公司详情'
		},
	},
	{
		path: 'serviceDetail',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationCenter/serviceDetail'),
		name: 'serviceDetail',
		meta: {
			title: '详情'
		},
	},
	{
		path: 'companyDetail',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationCenter/companyDetail'),
		name: 'companyDetail',
		meta: {
			title: '详情'
		},
	},
	{
		path: 'individualOpenAccount',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationCenter/openAccount'),
		name: 'individualOpenAccount',
		meta: {
			title: '开户',
			keepAlive: true
		},

	},
	{
		path: 'individualDetail',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationDetails/index'),
		name: 'individualDetail',
		meta: {
			title: '申报明细',
			keepAlive: true
		},

	},
	{
		path: 'declarationDetail',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationDetails/detail'),
		name: 'declarationDetail',
		meta: {
			title: '申报明细详情',
			keepAlive: true
		},
	
	},
	{
		path: 'identityInfo',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationCenter/identityInfo'),
		name: 'identityInfo',
		meta: {
			title: '身份信息报送表',
			keepAlive: true
		},
	
	},
	{
		path: 'personInfoCollect',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationCenter/personInfoCollect'),
		name: 'personInfoCollect',
		meta: {
			title: '人员信息采集',
			keepAlive: true
		},
	
	},
	{
		path: 'laborIncome',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationCenter/laborIncome'),
		name: 'laborIncome',
		meta: {
			title: '劳动报酬所得',
			keepAlive: true
		},
	
	},
	{
		path: 'incomeInfo',
		component: () => import( /* webpackChunkName: "common-list" */
			'@/pages/individualTax/declarationCenter/incomeInfo'),
		name: 'incomeInfo',
		meta: {
			title: '收入信息报送表',
			keepAlive: true
		},
	
	}
]